import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { fade } from '@material-ui/core';
import MultiselectControl from 'Components/UI/MultiselectControl';

const styles = (theme) => ({
  root: {
    width: '100%',
    '& .MuiFilledInput-root': {
      background: 'transparent',
    },
    '& .MuiSelect-root': {
      fontWeight: theme.typography.fontWeightMedium,
      background: theme.palette.facet.accentBlue20,
      borderRadius: theme.radius.md,
      padding: theme.spacing(4, 0, 2, 1.5),
    },
    '& .MuiFormLabel-root': {
      zIndex: 1,
      fontWeight: theme.typography.fontWeightFacetBook,
      color: theme.palette.facet.primaryBlue,
      fontSize: theme.typography.h5.fontSize,
    },
    '& .MuiInputLabel-filled': {
      transform: 'translate(20px, 25px) scale(1)',
    },
    '& .MuiInputLabel-shrink': {
      color: theme.palette.common.black,
      transform: 'translate(12px, 15px) scale(0.75)',
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.facet.primaryBlue,
    },
    // --------- Start Disabling ----------------
    '& .MuiFormLabel-root.Mui-disabled:not(.Mui-error)': {
      color: theme.palette.facet.primaryGray,
    },
    '& .MuiInputBase-root.Mui-disabled:not(.Mui-error)': {
      '& .MuiSelect-root': {
        color: theme.palette.facet.primaryGray,
        backgroundColor: theme.palette.action.disabledBackground,
        '&:hover': {
          backgroundColor: theme.palette.action.disabledBackground,
        },
      },
      '& .MuiInputBase-input': {
        color: theme.palette.facet.primaryGray,
      },
      '& .MuiSvgIcon-root': {
        color: theme.palette.facet.primaryGray,
      },
    },
    // --------- End Disabling ----------------
    // --------- Start Error ----------------
    '& .MuiFormLabel-root.Mui-error': {
      color: fade(theme.palette.error.main, 0.8),
    },
    '& .MuiInputBase-root.Mui-error': {
      '& .MuiSelect-root': {
        color: fade(theme.palette.error.main, 0.8),
        backgroundColor: fade(theme.palette.error.main, 0.3),
        '&:hover': {
          backgroundColor: fade(theme.palette.error.main, 0.3),
        },
      },
      '& .MuiInputBase-input': {
        color: fade(theme.palette.error.main, 0.8),
      },
      '& .MuiSvgIcon-root': {
        color: fade(theme.palette.error.main, 0.8),
      },
    },
    // --------- End Error ----------------
    paddingBottom: theme.spacing(0),
  },
  noLabel: {
    '& .MuiSelect-root': {
      padding: theme.spacing(3, 0, 3, 1.5),
    },
  },
});

const MultiselectField = ({
  className,
  classes,
  LabelProps,
  SelectProps,
  label,
  ...rest
}) => {
  return (
    <MultiselectControl
      className={classNames(classes.root, className, { [classes.noLabel]: !label })}
      variant={'filled'}
      LabelProps={{
        ...LabelProps,
        classes: {
          root: classes.label,
        },
      }}
      SelectProps={{
        ...SelectProps,
        classes: {
          root: classes.selectField,
          focused: classes.label,
        },
        disableUnderline: true,
      }}
      label={label}
      {...rest}
    />
  );
};

MultiselectField.defaultProps = {
  className: '',
  LabelProps: {},
  SelectProps: {},
};

MultiselectField.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  LabelProps: PropTypes.object,
  SelectProps: PropTypes.object,
};

export default withStyles(styles)(MultiselectField);
